import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import de from './locales/de.json'
import en from './locales/en.json'

const resources = {
  de: { translation: de },
  en: { translation: en },
}

const instance = i18n.use(initReactI18next)

if (typeof window !== 'undefined') {
  instance.use(LanguageDetector)
}

instance.init({
  resources,
  fallbackLng: 'de',
  lng: typeof window === 'undefined' ? 'de' : undefined,
  supportedLngs: ['de', 'en'],
  interpolation: {
    escapeValue: false,
  },
  ...(typeof window !== 'undefined' && {
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  }),
})

export default i18n
